export const DEV_THROW_ERROR_BOUNDARY_EVENT = 'tn:dev-throw-error-boundary' as const;

export const DEFAULT_DEV_ERROR_MESSAGE = 'DevTools: intentional error boundary test';

export type DevThrowErrorBoundaryDetail = {
    message?: string;
    source?: 'devtools' | 'console';
};

export function dispatchDevThrowErrorBoundary(detail: DevThrowErrorBoundaryDetail = {}): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(
        new CustomEvent<DevThrowErrorBoundaryDetail>(DEV_THROW_ERROR_BOUNDARY_EVENT, {
            detail: { source: 'devtools', ...detail },
        }),
    );
}

export function subscribeDevThrowErrorBoundary(
    callback: (detail: DevThrowErrorBoundaryDetail) => void,
): () => void {
    if (typeof window === 'undefined') return () => {};
    const handler = (event: Event) => {
        callback((event as CustomEvent<DevThrowErrorBoundaryDetail>).detail ?? {});
    };
    window.addEventListener(DEV_THROW_ERROR_BOUNDARY_EVENT, handler);
    return () => window.removeEventListener(DEV_THROW_ERROR_BOUNDARY_EVENT, handler);
}
